import { palette } from "./theme";

export const darkTheme = {
  palette: {
    ...palette,
    mode: "dark",
    background: {
      default: "#0d011d",
    },
  },
  components: {
    // Name of the component
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: "0.84vw",
        },
      },
    },
  },
};
